import { render, staticRenderFns } from "./AdminUserCommission.vue?vue&type=template&id=b783bd92"
import script from "./AdminUserCommission.vue?vue&type=script&lang=js"
export * from "./AdminUserCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports